var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-flyer-container",attrs:{"id":_vm.container_id}})
}
var staticRenderFns = []

export { render, staticRenderFns }